var map = {
	"./a.mp3": 775,
	"./af.mp3": 827,
	"./b.mp3": 51,
	"./bf.mp3": 297,
	"./c.mp3": 400,
	"./c2.mp3": 339,
	"./d.mp3": 846,
	"./d2.mp3": 673,
	"./df.mp3": 108,
	"./df2.mp3": 885,
	"./e.mp3": 396,
	"./e2.mp3": 290,
	"./ef.mp3": 786,
	"./ef2.mp3": 945,
	"./f.mp3": 906,
	"./g.mp3": 237,
	"./gf.mp3": 335
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 558;